@if (authService.isAuthenticated()) {
  <app-page [titolo]="saluto()" sottotitolo="Come va la redazione, adesso">
    <button azioni type="button" mat-flat-button color="primary" routerLink="/gestione-articoli/articoli/nuovo">
      <mat-icon>add</mat-icon>
      Nuovo articolo
    </button>

    @if (caricamento()) {
      <mat-progress-bar mode="indeterminate" aria-label="Caricamento dei numeri" />
    }

    @if (errore(); as motivo) {
      <div class="tabella__errore" role="alert">
        <mat-icon aria-hidden="true">error_outline</mat-icon>
        <div>
          <p class="tabella__errore-titolo">{{ motivo }}</p>
          <button type="button" mat-button (click)="caricaStatistiche()">Riprova</button>
        </div>
      </div>
    }

    <!-- I numeri della giornata. Ognuno apre l'elenco già filtrato. -->
    <div class="riquadri">
      @for (riquadro of riquadri; track riquadro.chiave) {
        <button
          type="button"
          class="riquadro riquadro--{{ riquadro.tono }}"
          [matTooltip]="riquadro.spiegazione"
          (click)="apriElenco(riquadro)"
        >
          <mat-icon class="riquadro__icona" aria-hidden="true">{{ riquadro.icona }}</mat-icon>
          <span class="riquadro__numero">{{ valore(riquadro.chiave) ?? '—' }}</span>
          <span class="riquadro__etichetta">{{ riquadro.etichetta }}</span>
        </button>
      }
    </div>

    <!-- Da dove riprendere -->
    <section class="scheda">
      <h2 class="scorciatoie__titolo">Ultimi articoli toccati</h2>

      @if (statistiche()?.ultimi?.length) {
        <ul class="recenti">
          @for (articolo of statistiche()!.ultimi; track articolo.id) {
            <li>
              <a class="recente" [routerLink]="['/gestione-articoli/articoli', articolo.id]">
                @if (stato(articolo); as s) {
                  <span class="stato stato--{{ s.codice }}">{{ s.etichetta }}</span>
                }
                <span class="recente__titolo">{{ articolo.titolo }}</span>
                @if (articolo.categoria?.nome) {
                  <span class="etichetta-chip">{{ articolo.categoria!.nome }}</span>
                }
                <span class="recente__quando" [matTooltip]="toccatoPreciso(articolo)">{{ toccato(articolo) }}</span>
              </a>
            </li>
          }
        </ul>
      } @else if (!caricamento() && !errore()) {
        <p class="recenti__vuoto">Nessun articolo ancora.</p>
      }
    </section>

    <!-- Le scorciatoie ai moduli restano, ma sotto ai numeri -->
    @for (modulo of authService.modules(); track modulo.title) {
      <section class="scheda">
        <h2 class="scorciatoie__titolo">{{ modulo.title }}</h2>
        <div class="scorciatoie">
          @for (voce of modulo.navigations; track voce.url) {
            <a class="scorciatoia" [routerLink]="voce.url">
              <mat-icon class="scorciatoia__icona">{{ voce.icon }}</mat-icon>
              <span class="scorciatoia__titolo">{{ voce.title }}</span>
            </a>
          }
        </div>
      </section>
    }
  </app-page>
} @else {
  <div class="accesso">
    <img src="/public/images/splash.png" alt="InfoOggi" class="accesso__logo" />
    <p class="accesso__testo">Pannello di redazione</p>
    <a mat-flat-button color="primary" [href]="loginUrl()" rel="noreferrer">Accedi</a>
  </div>
}
